import http from "@/http/aisea/axios_v2";
const resource = "/enterprises/crews/ashore";
import qs from "qs";

/**
 * (V2) 下船中船員一覧取得API
 * 
 * @param {Object} params - 以下の条件で絞り込みが可能です。
 * details:
 *   - CREW_AVAILABLE_ROLE
 *   - CREW_LICENSE
 *   - CREW_RESPONSIBILITY
 */
export default {
  fetch(params) {
    return http.get(`${resource}`, {
      params: params,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
  },  
};
